const str = '';
const int = 0;

export const fileModelGet = ({
    id = str,
    name = str,
    nameCustom = str,
    path = str,
    size = int,
    sizeCustom = str,
    type = str,
    url = str}) => {
    return {
        id: id,
        name: name,
        nameCustom: nameCustom,
        path: path,
        size: size,
        sizeCustom: sizeCustom,
        type: type,
        url: url,
    };
}